<template>
  <div :class="['search-wrap', show ? 'show' : '']">
    <div class="search-header">
      <div class="search-close" @click="onClose">
        <div class="close"></div>
      </div>
      <input class="txt" type="text" :placeholder="keyWord" v-model="searchKey" />
      <div class="search-btn" @click="goSearchPage"></div>
    </div>
    <div class="mod-index-search">
      <ul class="search-item" v-if="showDefault && recommends">
        <li>
          <a class="qj-search">全局搜索</a>
        </li>
        <li v-for="(item, index) in recommends" :key="index">
          <a :href="item.linkUrl">{{ item.word }}</a>
        </li>
      </ul>
      <div class="search-result" v-if="!showDefault">
        <div class="result" v-for="(item, index) in searchResult" :key="index">
          <div class="result-title">{{ item.name }}({{ item.number }})</div>
          <div class="result-list" v-for="(cItem, cIndex) in item.value" :key="cIndex">
            <a :href="cItem.url">{{ cItem.name }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import create from '../create'
import fetchJsonp from 'fetch-jsonp'
import env from 'utils/clientEnv'

export default create({
  name: 'search',
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      list: [],
      PORTAL_HOST: '//www.vivo.com.cn',
      keyWord: '',
      recommends: [],
      searchKey: '',
      searchTimeout: -1,
      searchResult: {},
      showDefault: true
    }
  },
  watch: {
    searchKey(sKey) {
      if (!sKey) {
        this.showDefault = true
        return
      }
      this.showDefault = false
      clearTimeout(this.searchTimeout)
      this.searchTimeout = setTimeout(() => {
        this.getSearchResult(sKey)
      }, 300)
    },
    show() {
      this.getRecWords()
      this.getHotWords()
    }
  },
  methods: {
    // 获取搜索默认词placeholder
    getRecWords() {
      fetchJsonp(`${this.PORTAL_HOST}/search/ajax/recWords`, { jsonpCallback: 'jsoncallback' })
        .then(res => {
          return res.json()
        })
        .then(data => {
          if (data && data.keyWord) {
            this.keyWord = data.keyWord
          }
        })
    },
    // 获取全局搜索热词
    getHotWords() {
      fetchJsonp(`${this.PORTAL_HOST}/search/recommends`, { jsonpCallback: 'jsoncallback' })
        .then(res => {
          return res.json()
        })
        .then(data => {
          if (data && data.recommends && data.recommends.length > 0) {
            this.recommends = data.recommends
          }
        })
    },
    getSearchResult(sKey) {
      fetchJsonp(`${this.PORTAL_HOST}/search/ajax/assResult?query=${sKey}`, { jsonpCallback: 'jsoncallback' })
        .then(res => {
          return res.json()
        })
        .then(data => {
          if (data && data.result) {
            this.searchResult = data.result
          }
        })
    },
    goSearchPage() {
      let q = this.searchKey ? this.searchKey : this.keyWord
      q = encodeURIComponent(q)
      if (env.isBankabc) {
        window.location.href = this.PORTAL_HOST + '/search?q=' + encodeURIComponent(q)
      } else {
        window.location.href = this.PORTAL_HOST + '/search?q=' + q
      }
    },
    onClose() {
      this.$emit('close')
    }
  }
})
</script>

<style lang="scss" scoped src="./index.scss"></style>
